export function getText(level, parent_company_name, location_name) {
  return level === 'company'
    ? `Automations enabled here will be used by all locations under ${parent_company_name}.`
    : `Automations enabled here will be used by ${location_name}.`
}
